export default  {
  "version": "3.0.2",
  "900130": {
    "EN": "Use this Rule if Drupal and WordPress Exclusion could be enabled",
    "KO": "Drupal 및 WordPress 제외를 사용할 수 있는 경우 사용"
  },
  "900300": {
    "EN": "Set the Max Number of Arguments (255)",
    "KO": "최대 인수 수 설정 (기본값: 255)"
  },
  "900310": {
    "EN": "Set the Max Length of Any Argument Name (100)",
    "KO": "인수 이름의 최대 길이 설정 (기본값: 100)"
  },
  "900320": {
    "EN": "Set the Max Length of Any Argument Value (400)",
    "KO": "모든 인수 값의 최대 길이 설정 (기본값: 400)"
  },
  "900330": {
    "EN": "Set the Max Length of All Combined Arguments (64000)",
    "KO": "결합 된 모든 인수의 최대 길이 설정 (기본값: 64000)"
  },
  "901001": {
    "EN": "Checks if crs-setup.conf was loaded",
    "KO": "crs-setup.conf가 업로드 되었는지 확인"
  },
  "901100": {
    "EN": "Default Inbound Anomaly Threshold Level Setup",
    "KO": "기본 인바운드 이상 임계값 수준 설정"
  },
  "901110": {
    "EN": "Default Outbound Anomaly Threshold Level Setup",
    "KO": "기본 아웃 바운드 이상 임계값 수준 설정"
  },
  "901120": {
    "EN": "Default Paranoia Level Setup",
    "KO": "기본 보안 정책 레벨 설정"
  },
  "901130": {
    "EN": "Default Sampling Percentage Setup",
    "KO": "기본 샘플링 백분율 설정"
  },
  "901140": {
    "EN": "Default Anomaly Scores Setup",
    "KO": "기본 이상 점수 설정"
  },
  "901141": {
    "EN": "Default Error Anomaly Scores Setup",
    "KO": "기본 오류 이상 점수 설정"
  },
  "901142": {
    "EN": "Default Warning Anomaly Scores Setup",
    "KO": "기본 경고 이상 점수 설정"
  },
  "901143": {
    "EN": "Default Notice Anomaly Scores Setup",
    "KO": "기본 공지 이상 점수 설정"
  },
  "901150": {
    "EN": "Default Do_Reput_Block Setup",
    "KO": "기본 Do_Reput_차단 설정"
  },
  "901152": {
    "EN": "Default Block Duration Setup",
    "KO": "기본 차단 기간 설정"
  },
  "901160": {
    "EN": "Default HTTP Policy : allowed_methods",
    "KO": "기본 HTTP 정책 : allowed_methods"
  },
  "901162": {
    "EN": "Default HTTP Policy : allowed_request_content_type",
    "KO": "기본 HTTP 정책 : allowed_request_content_type"
  },
  "901163": {
    "EN": "Default HTTP Policy : allowed_http_versions",
    "KO": "기본 HTTP 정책 : allowed_http_versions"
  },
  "901164": {
    "EN": "Default HTTP Policy : restricted_extensions",
    "KO": "기본 HTTP 정책 : restricted_extensions"
  },
  "901165": {
    "EN": "Default HTTP Policy : restricted_headers",
    "KO": "기본 HTTP 정책 : restricted_headers"
  },
  "901166": {
    "EN": "Default HTTP Policy: static_extensions",
    "KO": "기본 HTTP 정책 : static_extensions"
  },
  "901200": {
    "EN": "Initialize Anomaly Scoring Variables",
    "KO": "이상 스코어 변수 초기화"
  },
  "901318": {
    "EN": "Initialize Collections : User-Agent Hash",
    "KO": "컬렉션 초기화 : User-Agent Hash"
  },
  "901321": {
    "EN": "Initialize Collections : Global and IP",
    "KO": "컬렉션 초기화 : Global and IP"
  },
  "901400": {
    "EN": "Checks The Sampling Percentage",
    "KO": "샘플링의 백분율 확인"
  },
  "901410": {
    "EN": "Checks The UNIQUE_ID",
    "KO": "UNIQUE_ID를 확인"
  },
  "901420": {
    "EN": "Checks The DURATION Count",
    "KO": "DURATION 수를 확인"
  },
  "901430": {
    "EN": "Checks The Pseudo Random Number",
    "KO": "허위의 난수 확인"
  },
  "901440": {
    "EN": "Checks The Pseudo Random Number",
    "KO": "허위의 난수 확인"
  },
  "901450": {
    "EN": "Sampling Decision : Disable the rule engine based on sampling percentage",
    "KO": "Sampling Decision : 샘플링 비율에 따라 규칙 엔진 사용 안함"
  },
  "9001000": {
    "EN": "Checks The crs_exclusion_drupal (check if rule 900130 is enabled)",
    "KO": "crs_exclusion_drupal의 규칙 확인(규칙 900130이 사용 가능한지 확인)"
},
"9001100": {
    "EN": "Drupal Rule Exclusion for Session Cookie : 942450 SQL Hex Encoding Identified",
    "KO": "세션 쿠키에 대한 Drupal 규칙 제외: 942450 룰셋"
},
"9001110": {
    "EN": "Drupal Rule Exclusion for Password",
    "KO": "암호에 대한 Drupal 규칙 제외"
},
"9001112": {
    "EN": "Drupal Rule Exclusion for Password",
    "KO": "암호에 대한 Drupal 규칙 제외"
},
"9001114": {
    "EN": "Drupal Rule Exclusion for Password",
    "KO": "암호에 대한 Drupal 규칙 제외"
},
"9001116": {
    "EN": "Drupal Rule Exclusion for Password",
    "KO": "암호에 대한 Drupal 규칙 제외"
},
"9001122": {
    "EN": "Drupal Rule Exclusion for Admin Settings",
    "KO": "관리자 설정에 대한 Drupal 규칙 제외"
},
"9001124": {
    "EN": "Drupal Rule Exclusion for Admin Settings",
    "KO": "관리자 설정에 대한 Drupal 규칙 제외"
},
"9001126": {
    "EN": "Drupal Rule Exclusion for Admin Settings",
    "KO": "관리자 설정에 대한 Drupal 규칙 제외"
},
"9001128": {
    "EN": "Drupal Rule Exclusion for Admin Settings",
    "KO": "관리자 설정에 대한 Drupal 규칙 제외"
},
"9001140": {
    "EN": "Drupal Rule Exclusion for Content and Descriptions",
    "KO": "콘텐츠 및 설명에 대한 Drupal 규칙 제외"
},
"9001160": {
    "EN": "Drupal Rule Exclusion for for form_build_id ,form_token and form_build_id",
    "KO": "for, form_build_id ,form_token and form_build_id에 대한 Drupal 규칙 제외"
},
"9001170": {
    "EN": "Drupal Rule Exclusion for Text Formats and Editors",
    "KO": "텍스트 형식 및 편집기에 대한 Drupal 규칙 제외"
},
"9001180": {
    "EN": "Drupal Rule Exclusion for WYSIWYG/CKEditor Assets and Upload",
    "KO": "WYSIWYG/CKEditor 애셋 및 업로드에 대한 Drupal 규칙 제외"
},
"9001182": {
    "EN": "Drupal Rule Exclusion for WYSIWYG/CKEditor Assets and Upload",
    "KO": "WYSIWYG/CKEditor 애셋 및 업로드에 대한 Drupal 규칙 제외"
},
"9001184": {
    "EN": "Drupal Rule Exclusion for WYSIWYG/CKEditor Assets and Upload",
    "KO": "WYSIWYG/CKEditor 애셋 및 업로드에 대한 Drupal 규칙 제외"
},
"9001200": {
    "EN": "Drupal Rule Exclusion for Content and Descriptions",
    "KO": "콘텐츠 및 설명에 대한 Drupal 규칙 제외"
},
"9001202": {
    "EN": "Drupal Rule Exclusion for Content and Descriptions",
    "KO": "콘텐츠 및 설명에 대한 Drupal 규칙 제외"
},
"9001204": {
    "EN": "Drupal Rule Exclusion for Content and Descriptions",
    "KO": "콘텐츠 및 설명에 대한 Drupal 규칙 제외"
},
"9001206": {
    "EN": "Drupal Rule Exclusion for Content and Descriptions",
    "KO": "콘텐츠 및 설명에 대한 Drupal 규칙 제외"
},
"9001208": {
    "EN": "Drupal Rule Exclusion for Content and Descriptions",
    "KO": "콘텐츠 및 설명에 대한 Drupal 규칙 제외"
},
"9001210": {
    "EN": "Drupal Rule Exclusion for Content and Descriptions",
    "KO": "콘텐츠 및 설명에 대한 Drupal 규칙 제외"
},
"9001212": {
    "EN": "Drupal Rule Exclusion for Content and Descriptions",
    "KO": "콘텐츠 및 설명에 대한 Drupal 규칙 제외"
},
"9001214": {
    "EN": "Drupal Rule Exclusion for Content and Descriptions",
    "KO": "콘텐츠 및 설명에 대한 Drupal 규칙 제외"
},
"9001216": {
    "EN": "Drupal Rule Exclusion for Content and Descriptions",
    "KO": "콘텐츠 및 설명에 대한 Drupal 규칙 제외"
},
"9002000": {
    "EN": "Checks The crs_exclusions_wordpress for phase 1 (check if rule 900130 is enabled)",
    "KO": "페이즈 1에서 crs_exclusions_wordpress의 규칙 확인(규칙 900130이 사용 가능한지 확인)"
},
"9002001": {
    "EN": "Checks The crs_exclusions_wordpress for phase 2 (check if rule 900130 is enabled)",
    "KO": "페이즈 2에서 crs_exclusions_wordpress의 규칙 확인(규칙 900130이 사용 가능한지 확인)"
},
"9002100": {
    "EN": "WordPress Rule Exclusion for Login form : User login password",
    "KO": "로그인 양식에 대한 WordPress 규칙 제외 : 사용자 로그인 비밀번호"
},
"9002120": {
    "EN": "WordPress Rule Exclusion for Login form : Reset password",
    "KO": "로그인 양식에 대한 WordPress 규칙 제외 : 비밀번호 재설정"
},
"9002130": {
    "EN": "WordPress Rule Exclusion for Live preview : Post comment",
    "KO": "실시간 미리보기에 대한 WordPress 규칙 제외 : 댓글 게시"
},
"9002150": {
    "EN": "WordPress Rule Exclusion for Live preview : Theme select",
    "KO": "실시간 미리보기에 대한 WordPress 규칙 제외 : 테마 선택"
},
"9002160": {
    "EN": "WordPress Rule Exclusion for Live preview : Appearance -> Widgets -> Live Preview",
    "KO": "실시간 미리보기에 대한 WordPress 규칙 제외 : 모양-> 위젯-> 실시간 미리보기"
},
"9002200": {
    "EN": "WordPress Rule Exclusion for Live preview : Self calls to wp-cron.php?doing_wp_cron=[timestamp]",
    "KO": "실시간 미리보기에 대한 WordPress 규칙 제외: wp-cron.doing_wp_cron=[timestamp]에 대한 자체 호출"
},
"9002300": {
    "EN": "WordPress Rule Exclusion for Cookies : WP Session Manager",
    "KO": "쿠키에 대한 WordPress 규칙 제외 : WP 세션 관리자"
},
"9002400": {
    "EN": "WordPress Rule Exclusion for WordPress Administration Back-End (wp-admin)",
    "KO": "WordPress 관리 백엔드에 대한 WordPress 규칙 제외(wp-admin)"
},
"9002401": {
    "EN": "WordPress Rule Exclusion for WordPress Administration Back-End (wp-admin)",
    "KO": "WordPress 관리 백엔드에 대한 WordPress 규칙 제외(wp-admin)"
},
"9002410": {
    "EN": "WordPress Rule Exclusion for WordPress Installation : exclude database password",
    "KO": "WordPress 설치를 위한 WordPress 규칙 제외: 데이터베이스 암호 제외"
},
"9002420": {
    "EN": "WordPress Rule Exclusion for WordPress Installation : exclude admin password",
    "KO": "WordPress 설치를 위한 WordPress 규칙 제외: admin 암호 제외"
},
"9002520": {
    "EN": "WordPress Rule Exclusion for User Management : Edit logged-in user",
    "KO": "User Management를 위한 WordPress 규칙 제외: logged-in user 수정"
},
"9002530": {
    "EN": "WordPress Rule Exclusion for User Management : Edit user",
    "KO": "User Management를 위한 WordPress 규칙 제외: user 수정"
},
"9002540": {
    "EN": "WordPress Rule Exclusion for User Management : Create user",
    "KO": "User Management를 위한 WordPress 규칙 제외: user 생성"
},
"9002600": {
    "EN": "WordPress General Exclusions",
    "KO": "WordPress 일반 제외"
},
"9002700": {
    "EN": "WordPress Rule Exclusion for Content Editing : Edit posts and pages",
    "KO": "내용 편집을 위한 WordPress 규칙 제외: 게시물 및 페이지 수정"
},
"9002710": {
    "EN": "WordPress Rule Exclusion for Content Editing : Autosave posts and pages",
    "KO": "내용 편집을 위한 WordPress 규칙 제외: 게시물 및 페이지 자동저장"
},
"9002720": {
    "EN": "WordPress Rule Exclusion for Content Editing : Edit menus",
    "KO": "내용 편집을 위한 WordPress 규칙 제외: 매뉴 수정"
},
"9002730": {
    "EN": "WordPress Rule Exclusion for Content Editing : Edit text widgets",
    "KO": "내용 편집을 위한 WordPress 규칙 제외: 텍스트 위젯 수정"
},
"9002740": {
    "EN": "WordPress Rule Exclusion for Content Editing : Reorder widgets",
    "KO": "내용 편집을 위한 WordPress 규칙 제외: 위젯 재정렬"
},
"9002750": {
    "EN": "WordPress Rule Exclusion for Content Editing : Create permalink sample for new post",
    "KO": "내용 편집을 위한 WordPress 규칙 제외: 새 게시물에 대한 영구 링크 샘플 생성"
},
"9002760": {
    "EN": "WordPress Rule Exclusion for Content Editing : Add external link to menu",
    "KO": "콘텐츠 편집을 위한 WordPress 규칙 제외 : 메뉴에 외부 링크 추가"
},
"9002800": {
    "EN": "WordPress Rule Exclusion for Options and Settings : Change site URL",
    "KO": "콘텐츠 편집을 위한 WordPress 규칙 제외 : 사이트 URL 변경"
},
"9002810": {
    "EN": "WordPress Rule Exclusion for Options and Settings : Permalink settings",
    "KO": "콘텐츠 편집을 위한 WordPress 규칙 제외 : 영구 링크 설정"
},
"9002820": {
    "EN": "WordPress Rule Exclusion for Options and Settings : blacklist and moderation list",
    "KO": "콘텐츠 편집을 위한 WordPress 규칙 제외 : 블랙리스트 및 중재 목록"
},
"9002900": {
    "EN": "WordPress Rule Exclusion for Helpers",
    "KO": "도우미를 위한 WordPress 규칙 제외"
},
"905100": {
    "EN": "Exception for Apache SSL pinger",
    "KO": "Apache SSL pinger에 대한 예외"
  },
  "905110": {
    "EN": "Exception for Apache internal dummy connection",
    "KO": "Apache 내부 더미 연결에 대한 예외"
},
"910100" : {
  "EN": "Client IP is from a HIGH Risk Country Location",
  "KO": "클라이언트의 IP가 경계 지역 IP 로 접근"
},
"910000": {
    "EN": "Request from Known Malicious Client",
    "KO": "알려진 악성 클라이언트의 요청"
  },
  "910120": {
    "EN": "Checks The Real-Time Block List to Skip",
    "KO": "스킵된 실시간 차단 목록 확인"
  },
  "910130": {
    "EN": "Skip HttpBL Checks if user has not defined one of the TX:block_* variables",
    "KO": "사용자가 TX:block_* 변수 중 하나를 정의하지 않은 경우 HttpBL 체크를 스킵"
  },
  "910140": {
    "EN": "Prevent Operator Error: RBL httpBl called but no key defined: set SecHttpBlKey",
    "KO": "연산자 오류 방지: RBL httpBl이 호출되었지만 정의된 키가 없음: SecHttpBlKey 설정"
  },
  "910150": {
    "EN": "HTTP Blacklist match for search engine IP",
    "KO": "검색 엔진 IP에 대한 HTTP 블랙리스트 일치"
  },
  "910160": {
    "EN": "HTTP Blacklist match for spammer IP",
    "KO": "spammer IP에 대한 HTTP 블랙리스트 일치"
  },
  "910170": {
    "EN": "HTTP Blacklist match for suspicious IP",
    "KO": "의심스러운 IP에 대한 HTTP 블랙리스트 일치"
  },
  "910180": {
    "EN": "HTTP Blacklist match for harvester IP",
    "KO": "harvester IP에 대한 HTTP 블랙리스트 일치"
  },
  "910190": {
    "EN": "Set The Real-Time Block List Check",
    "KO": "실시간 차단 목록 확인 설정"
  },
  "911100": {
    "EN": "Not Allowed Request Methods",
    "KO": "정책에서 허용하지 않는 메서드"
},
"912100": {
    "EN": "Skip if variables defining DoS Protection are not set for phase 1",
    "KO": "DoS 보호를 정의하는 변수가 1 단계에 대해 설정되지 않은 경우 건너 뛰기"
  },
  "912110": {
    "EN": "Skip if variables defining DoS Protection are not set for phase 5",
    "KO": "DoS 보호를 정의하는 변수가 5 단계에 대해 설정되지 않은 경우 건너 뛰기"
  },
  "912120": {
    "EN": "DoS Block and Track of requests and log",
    "KO": "DoS 차단 및 요청 및 로그 추적"
  },
  "912130": {
    "EN": "DoS Block and Track of requests but don't log",
    "KO": "DoS 차단 및 요청하나 로그 기록을 하지 않음"
  },
  "912140": {
    "EN": "Anti-Automation / DoS Protection : Skip if we have blocked the request",
    "KO": "Anti-Automation / DoS Protection: 요청을 차단한 경우 스킵합니다."
  },
  "912150": {
    "EN": "DOS Counter: Count the number of requests to non-static resources",
    "KO": "DOS 카운터: 비정적 리소스에 대한 요청 수 카운트"
  },
  "912160": {
    "EN": "Checks DOS Counter : raise from 0 to 1",
    "KO": "DOS 카운터 확인 : 0에서 1로 올림"
  },
  "912161": {
    "EN": "Checks DOS Counter : raise from 1 to 2",
    "KO": "DOS 카운터 확인 : 1에서 2로 올림"
  },
  "912170": {
    "EN": "Potential DoS Attack if The DOS_BURST_COUNTER is greater than 2",
    "KO": "DOS_BUST_CANTER가 2보다 클 경우 잠재적인 DoS 공격으로 인지"
  },
  "912171": {
    "EN": "Potential DoS Attack if The DOS_BURST_COUNTER is greater than 1",
    "KO": "DOS_BUST_CANTER가 1보다 클 경우 잠재적인 DoS 공격으로 인지"
},
"913100": {
    "EN": "Found User-Agent associated with security scanner",
    "KO": "보안 스캐너와 연결된 사용자-에이전트 발견"
  },
  "913110": {
    "EN": "Found Request Header associated with security scanner",
    "KO": "보안 스캐너와 연결된 요청 헤더 발견"
  },
  "913120": {
    "EN": "Found Request filename/argument associated with security scanner",
    "KO": "보안 스캐너와 연결된 요청 파일 이름/인수 발견"
  },
  "913101": {
    "EN": "Found User-Agent associated with scripting/generic HTTP client",
    "KO": "스크립팅/일반 HTTP 클라이언트와 연결된 사용자-에이전트 발견"
  },
  "913102": {
    "EN": "Found User-Agent associated with web crawler/bot",
    "KO": "웹 크롤러/봇과 연결된 사용자-에이전트 발견"
},
"920100": {
    "EN": "Invalid HTTP Request Line",
    "KO": "잘못된 HTTP 요청 라인"
  },
  "920120": {
    "EN": "Attempted multipart/form-data bypass",
    "KO": "다중 파트/폼 데이터 바이패스 시도"
  },
  "920130": {
    "EN": "Failed to parse request body.",
    "KO": "요청 본문을 구문 분석하지 못했습니다."
  },
  "920140": {
    "EN": "Multipart request body failed strict validation",
    "KO": "Multipart 요청 본문에서 엄격한 유효성 검사에 실패 했습니다."
  },
  "920160": {
    "EN": "Content-Length HTTP header is not numeric.",
    "KO": "콘텐츠-길이 HTTP 헤더가 숫자가 아닙니다."
  },
  "920170": {
    "EN": "GET or HEAD Request with Body Content.",
    "KO": "본문 콘텐츠를 통한 GET 또는 HEAD 요청."
  },
  "920180": {
    "EN": "POST request missing Content-Length Header.",
    "KO": "POST 요청에 콘텐츠-길이 헤더가 없습니다."
  },
  "920190": {
    "EN": "Range = Invalid Last Byte Value.",
    "KO": "범위 = 마지막 바이트 값이 잘못되었습니다."
  },
  "920210": {
    "EN": "Multiple/Conflicting Connection Header Data Found.",
    "KO": "여러 개의 충돌하는 연결 헤더 데이터가 발견되었습니다."
  },
  "920220": {
    "EN": "URL Encoding Abuse Attack Attempt",
    "KO": "URL Encoding 남용 공격 시도"
  },
  "920240": {
    "EN": "URL Encoding Abuse Attack Attempt",
    "KO": "URL Encoding 남용 공격 시도"
  },
  "920250": {
    "EN": "UTF8 Encoding Abuse Attack Attempt",
    "KO": "UTF8 Encoding 남용 공격 시도"
  },
  "920260": {
    "EN": "Unicode Full/Half Width Abuse Attack Attempt",
    "KO": "유니코드 전자/반자 남용 공격 시도"
  },
  "920270": {
    "EN": "Invalid Character in request (null character)",
    "KO": "요청에 잘못된 문자(null 문자)"
  },
  "920280": {
    "EN": "Request Missing a Host Header",
    "KO": "호스트 헤더가 누락된 요청"
  },
  "920290": {
    "EN": "Empty Host Header",
    "KO": "빈 호스트 헤더"
  },
  "920310": {
    "EN": "Request Has an Empty Accept Header",
    "KO": "요청에 빈 Accept 헤더가 있음"
  },
  "920311": {
    "EN": "Request Has an Empty Accept Header",
    "KO": "요청에 빈 Accept 헤더가 있음"
  },
  "920330": {
    "EN": "Empty User Agent Header",
    "KO": "빈 사용자 에이전트 헤더"
  },
  "920340": {
    "EN": "Request Containing Content but Missing Content-Type header",
    "KO": "요청에 콘텐츠는 있지만 Content-Type 헤더 누락"
  },
  "920350": {
    "EN": "Host Header is a numeric IP address",
    "KO": "호스트 헤더가 숫자 IP 주소"
  },
  "920380": {
    "EN": "Too Many Arguments in request",
    "KO": "요청에 인수가 너무 많음"
  },
  "920360": {
    "EN": "Argument Name too long",
    "KO": "인수 이름이 너무 김"
  },
  "920370": {
    "EN": "Argument Value too long",
    "KO": "인수 값이 너무 김"
  },
  "920390": {
    "EN": "Total Arguments Size exceeded",
    "KO": "총 인수 크기 초과"
  },
  "920400": {
    "EN": "Uploaded File Size too large",
    "KO": "업로드된 파일 크기가 너무 큼"
  },
  "920410": {
    "EN": "Total Uploaded Files Size too large",
    "KO": "업로드된 총 파일 크기가 너무 큼"
  },
  "920420": {
    "EN": "Request Content Type Not Allowed by policy",
    "KO": "요청 콘텐츠 유형이 정책에서 허용되지 않음"
  },
  "920430": {
    "EN": "HTTP Protocol Version Not Allowed by policy",
    "KO": "HTTP 프로토콜 버전이 정책에서 허용되지 않음"
  },
  "920440": {
    "EN": "URL File Extension Restricted by policy",
    "KO": "URL 파일 확장명이 정책에서 허용되지 않음"
  },
  "920450": {
    "EN": "HTTP header Restricted by policy (%@{MATCHED_VAR})",
    "KO": "HTTP 헤더가 정책에서 제한됨(%@{MATCHED_VAR})"
  },
  "920200": {
    "EN": "Range = Too many fields (6 or more)",
    "KO": "범위 = 필드가 너무 많음(6개 이상)"
  },
  "920201": {
    "EN": "Range = Too many fields for pdf request (35 or more)",
    "KO": "범위 = pdf 요청에 대한 필드가 너무 많음(35개 이상)"
  },
  "920230": {
    "EN": "Multiple URL Encoding Detected",
    "KO": "여러 URL Encoding이 감지됨"
  },
  "920300": {
    "EN": "Request Missing an Accept Header",
    "KO": "Accept 헤더가 누락된 요청"
  },
  "920271": {
    "EN": "Invalid Character in request (non printable characters)",
    "KO": "요청에 잘못된 문자(인쇄할 수 없는 문자)"
  },
  "920320": {
    "EN": "Missing User Agent Header",
    "KO": "사용자 에이전트 헤더 누락"
  },
  "920121": {
    "EN": "Attempted multipart/form-data bypass",
    "KO": "다중 파트/폼 데이터 바이패스 시도"
  },
  "920272": {
    "EN": "Invalid Character in request",
    "KO": "요청에 잘못된 문자(ascii 127 미만의 인쇄 가능한 문자 이외의)"
  },
  "920202": {
    "EN": "Range = Too many fields for pdf request (6 or more)",
    "KO": "범위 = pdf 요청에 대한 필드가 너무 많음(6개 이상)"
  },
  "920273": {
    "EN": "Invalid Character in request (outside of very strict set)",
    "KO": "요청에 잘못된 문자(매우 엄격한 집합 이외의)"
  },
  "920274": {
    "EN": "Invalid Character in request headers (outside of very strict set)",
    "KO": "요청 헤더에 잘못된 문자(매우 엄격한 집합 이외의)"
  },
  "920460": {
    "EN": "Abnormal Escape Characters Detected",
    "KO": "비정상 이스케이프 문자"
},
"921100": {
    "EN": "HTTP Request Smuggling Attack",
    "KO": "HTTP 요청 밀반입 공격"
  },
  "921110": {
    "EN": "HTTP Request Smuggling Attack",
    "KO": "HTTP 요청 밀반입 공격"
  },
  "921120": {
    "EN": "HTTP Response Splitting Attack",
    "KO": "HTTP 응답 분할 공격"
  },
  "921130": {
    "EN": "HTTP Response Splitting Attack",
    "KO": "HTTP 응답 분할 공격"
  },
  "921140": {
    "EN": "HTTP Header Injection Attack via headers",
    "KO": "헤더를 통한 HTTP 헤더 삽입 공격"
  },
  "921150": {
    "EN": "HTTP Header Injection Attack via payload (CR/LF detected)",
    "KO": "페이로드를 통한 HTTP 헤더 삽입 공격(CR/LF 발견)"
  },
  "921160": {
    "EN": "HTTP Header Injection Attack via payload",
    "KO": "페이로드를 통한 HTTP 헤더 삽입 공격(CR/LF 및 헤더-이름 발견)"
  },
  "921151": {
    "EN": "HTTP Header Injection Attack via payload (CR/LF detected)",
    "KO": "페이로드를 통한 HTTP 헤더 삽입 공격(CR/LF 발견)"
  },
  "921170": {
    "EN": "HTTP Parameter Pollution",
    "KO": "HTTP 매개 변수 오염"
  },
  "921180": {
    "EN": "HTTP Parameter Pollution",
    "KO": "HTTP 매개 변수 오염 (% {TX. 1})"
},
"930100": {
    "EN": "Path Traversal Attack (/../)",
    "KO": "경로 탐색 공격(/../)"
  },
  "930110": {
    "EN": "Path Traversal Attack (/../)",
    "KO": "경로 탐색 공격(/../)"
  },
  "930120": {
    "EN": "OS File Access Attempt",
    "KO": "OS 파일 액세스 시도"
  },
  "930130": {
    "EN": "Restricted File Access Attempt",
    "KO": "제한된 파일 액세스 시도"
},
"931100": {
    "EN": "Possible Remote File Inclusion Attack = URL Parameter using IP Address",
    "KO": "가능한 원격 파일 포함(RFI) 공격 = IP 주소를 사용하는 URL 매개 변수"
  },
  "931110": {
    "EN": "Possible Remote File Inclusion Attack = Common RFI Vulnerable Parameter Name used w/URL Payload",
    "KO": "가능한 원격 파일 포함(RFI) 공격 = 일반 RFI 취약한 매개 변수 이름이 URL 페이로드에 사용됨"
  },
  "931120": {
    "EN": "Possible Remote File Inclusion Attack = URL Payload Used w/Trailing Question Mark Character (?)",
    "KO": "가능한 원격 파일 포함(RFI) 공격 = URL 페이로드가 후행 물음표 문자(?)에 사용됨"
  },
  "931130": {
    "EN": "Possible Remote File Inclusion Attack = Off-Domain Reference/Link",
    "KO": "가능한 원격 파일 포함(RFI) 공격 = 오프-도메인 참조/링크"
},
"932100": {
    "EN": "Remote Command Execution: Unix Command Injection",
    "KO": "원격 명령 실행: Unix 명령 삽입"
  },
  "932105": {
    "EN": "Remote Command Execution: Unix Command Injection",
    "KO": "원격 명령 실행: Unix 명령 삽입"
  },
  "932110": {
    "EN": "Remote Command Execution: Windows Command Injection",
    "KO": "원격 명령 실행: Windows 명령 삽입"
  },
  "932115": {
    "EN": "Remote Command Execution: Windows Command Injection",
    "KO": "원격 명령 실행: Windows 명령 삽입"
  },
  "932120": {
    "EN": "Remote Command Execution = Windows PowerShell Command Found",
    "KO": "원격 명령 실행 = Windows PowerShell 명령 발견"
  },
  "932130": {
    "EN": "Remote Command Execution = Unix Shell Expression Found",
    "KO": "원격 명령 실행 = Unix 셸 식 발견"
  },
  "932140": {
    "EN": "Remote Command Execution = Windows FOR/IF Command Found",
    "KO": "원격 명령 실행 = Windows FOR/IF 명령 발견"
  },
  "932150": {
    "EN": "Remote Command Execution: Direct Unix Command Execution",
    "KO": "원격 명령 실행: Unix 명령 직접 실행"
  },
  "932160": {
    "EN": "Remote Command Execution = Unix Shell Code Found",
    "KO": "원격 명령 실행 = Unix 셸 코드 발견"
  },
  "932170": {
    "EN": "Remote Command Execution = Shellshock (CVE-2014-6271)",
    "KO": "원격 명령 실행 = Shellshock(CVE-2014-6271)"
  },
  "932171": {
    "EN": "Remote Command Execution = Shellshock (CVE-2014-6271)",
    "KO": "원격 명령 실행 = Shellshock(CVE-2014-6271)"
},
"933100": {
    "EN": "PHP Injection Attack = Opening/Closing Tag Found",
    "KO": "PHP 삽입 공격 = 여는/닫는 태그 발견"
  },
  "933110": {
    "EN": "PHP Injection Attack = PHP Script File Upload Found",
    "KO": "PHP 삽입 공격 = PHP 스크립트 파일 업로드 발견"
  },
  "933120": {
    "EN": "PHP Injection Attack = Configuration Directive Found",
    "KO": "PHP 삽입 공격 = 구성 지시문 발견"
  },
  "933130": {
    "EN": "PHP Injection Attack = Variables Found",
    "KO": "PHP 삽입 공격 = 변수 발견"
  },
  "933140": {
    "EN": "PHP Injection Attack: I/O Stream Found",
    "KO": "PHP 삽입 공격: i/o 스트림이 있습니다."
  },
  "933150": {
    "EN": "PHP Injection Attack = High-Risk PHP Function Name Found",
    "KO": "PHP 삽입 공격 = 고위험 PHP 함수 이름 발견"
  },
  "933160": {
    "EN": "PHP Injection Attack = High-Risk PHP Function Call Found",
    "KO": "PHP 삽입 공격 = 고위험 PHP 함수 호출 발견"
  },
  "933170": {
    "EN": "PHP Injection Attack: Serialized Object Injection",
    "KO": "PHP 삽입 공격: 직렬화 된 개체 삽입"
  },
  "933180": {
    "EN": "PHP Injection Attack = Variable Function Call Found",
    "KO": "PHP 삽입 공격 = 변수 함수 호출 발견"
  },
  "933151": {
    "EN": "PHP Injection Attack: Medium-Risk PHP Function Name Found",
    "KO": "PHP 삽입 공격: Medium-Risk PHP 함수 이름을 찾았습니다."
  },
  "933161": {
    "EN": "PHP Injection Attack: Low-Value PHP Function Call Found",
    "KO": "PHP 삽입 공격: Low-Value PHP 함수 호출을 찾았습니다."
  },
  "933111": {
    "EN": "PHP Injection Attack: PHP Script File Upload Found",
    "KO": "PHP 삽입 공격: PHP 스크립트 파일 업로드 찾음"
},
"941100": {
    "EN": "XSS Attack Detected via libinjection",
    "KO": "libinjection을 통한 XSS 공격 감지됨"
  },
  "941110": {
    "EN": "XSS Filter - Category 1 = Script Tag Vector",
    "KO": "XSS 필터 - 범주 1 = 스크립트 태그 벡터"
  },
  "941120": {
    "EN": "XSS Filters - Category 2 = XSS Vector",
    "KO": "XSS 필터 - 범주 2 = XSS 벡터"
  },
  "941140": {
    "EN": "XSS Filter - Category 4 = Javascript URI Vector",
    "KO": "XSS 필터 - 범주 4 = Javascript URI 벡터"
  },
  "941160": {
    "EN": "NoScript XSS InjectionChecker: HTML Injection",
    "KO": "NoScript XSS InjectionChecker: HTML 주입"
  },
  "941170": {
    "EN": "NoScript XSS InjectionChecker: Attribute Injection",
    "KO": "NoScript XSS InjectionChecker: 특성 주입"
  },
  "941180": {
    "EN": "Node-Validator Blacklist Keywords",
    "KO": "노드 검사기 블랙리스트 키워드"
  },
  "941190": {
    "EN": "XSS using style sheets",
    "KO": "스타일 시트를 사용 하는 XSS"
  },
  "941200": {
    "EN": "XSS using VML frames",
    "KO": "VML 프레임을 사용 하는 XSS"
  },
  "941210": {
    "EN": "XSS using obfuscated Javascript",
    "KO": "난독 처리 Javascript를 사용 하는 XSS"
  },
  "941220": {
    "EN": "XSS using obfuscated VB Script",
    "KO": "난독 처리 되지 않은 VB 스크립트를 사용 하는 XSS"
  },
  "941230": {
    "EN": "XSS using 'embed' tag",
    "KO": " Embed ' 태그를 사용 하는 XSS"
  },
  "941240": {
    "EN": "XSS using 'import' or 'implementation' attribute",
    "KO": " Import ' 또는 ' 구현 ' 특성을 사용 하는 XSS"
  },
  "941250": {
    "EN": "IE XSS Filters - Attack Detected",
    "KO": "IE XSS 필터-공격 감지 됨"
  },
  "941260": {
    "EN": "XSS using 'meta' tag",
    "KO": "' Meta ' 태그를 사용 하는 XSS"
  },
  "941270": {
    "EN": "XSS using 'link' href",
    "KO": " Link ' href를 사용 하는 XSS"
  },
  "941280": {
    "EN": "XSS using 'base' tag",
    "KO": " Base ' 태그를 사용 하는 XSS"
  },
  "941290": {
    "EN": "XSS using 'applet' tag",
    "KO": " applet ' 태그를 사용 하는 XSS"
  },
  "941300": {
    "EN": "XSS using 'object' tag",
    "KO": " Object ' 태그를 사용 하는 XSS"
  },
  "941310": {
    "EN": "US-ASCII Malformed Encoding XSS Filter - Attack Detected.",
    "KO": "US-ASCII 잘못된 형식의 Encoding XSS 필터 - 공격 감지됨."
  },
  "941350": {
    "EN": "UTF-7 Encoding IE XSS - Attack Detected.",
    "KO": "UTF-7 Encoding IE XSS - 공격 감지됨."
  },
  "941101": {
    "EN": "XSS Attack Detected via libinjection",
    "KO": "libinjection을 통한 XSS 공격 감지됨"
  },
  "941150": {
    "EN": "XSS Filter - Category 5 = Disallowed HTML Attributes",
    "KO": "XSS 필터 - 범주 5 = 허용되지 않는 HTML 특성"
  },
  "941320": {
    "EN": "Possible XSS Attack Detected - HTML Tag Handler",
    "KO": "가능한 XSS 공격 감지됨 - HTML 태그 처리기"
  },
  "941330": {
    "EN": "IE XSS Filters - Attack Detected.",
    "KO": "IE XSS 필터 - 공격 감지됨."
  },
  "941340": {
    "EN": "IE XSS Filters - Attack Detected.",
    "KO": "IE XSS 필터 - 공격 감지됨."
},
"942100": {
    "EN": "SQL Injection Attack Detected via libinjection",
    "KO": "libinjection을 통한 SQL 삽입 공격 감지됨"
  },
  "942140": {
    "EN": "SQL Injection Attack = Common DB Names Detected",
    "KO": "SQL 삽입 공격 = 일반 DB 이름 감지됨"
  },
  "942160": {
    "EN": "Detects blind sqli tests using sleep() or benchmark().",
    "KO": "sleep() 또는 benchmark()를 사용하는 블라인드 sqli 테스트 감지."
  },
  "942170": {
    "EN": "Detects SQL benchmark and sleep Injection Attempts including conditional queries",
    "KO": "조건부 쿼리를 포함하여 SQL benchmark 및 sleep 삽입 공격 감지"
  },
  "942190": {
    "EN": "Detects MSSQL Code Execution and Information Gathering Attempts",
    "KO": "MSSQL 코드 실행 및 정보 수집 시도 감지"
  },
  "942220": {
    "EN": "Looking for integer overflow attacks",
    "KO": "정수 오버플로 공격을 찾고 3.0.00738585072를 제외 하 고 skipfish에서 가져옵니다."
  },
  "942230": {
    "EN": "Detects conditional SQL injection attempts",
    "KO": "조건부 SQL 삽입 시도 감지"
  },
  "942240": {
    "EN": "Detects MySQL charset switch and MSSQL DoS attempts",
    "KO": "MySQL 문자 집합 스위치 및 MSSQL DoS 시도를 검색 합니다."
  },
  "942250": {
    "EN": "Detects MATCH AGAINST, MERGE and EXECUTE IMMEDIATE injections",
    "KO": "일치 항목을 검색 하고 병합 하고 즉시 삽입을 실행 합니다."
  },
  "942270": {
    "EN": "Looking for Basic sql Injection. Common attack string for mysql oracle and others",
    "KO": "기본적인 sql 삽입 검색. Mysql oracle 및 기타에 대한 일반적인 공격 문자열"
  },
  "942280": {
    "EN": "Detects Postgres pg_sleep Injection, wait for Delay Attacks and Database Shutdown Attempts",
    "KO": "Postgres pg_sleep 주입 waitfor 지연 공격 및 데이터베이스 종료 시도를 검색 합니다."
  },
  "942290": {
    "EN": "Finds Basic MongoDB SQL Injection attempts",
    "KO": "기본적인 MongoDB SQL 삽입 시도 찾기"
  },
  "942320": {
    "EN": "Detects MySQL and PostgreSQL stored procedure/function Injections",
    "KO": "MySQL 및 PostgreSQL에 저장된 저장 프로시저/함수 삽입 감지"
  },
  "942350": {
    "EN": "Detects MySQL UDF Injection and other data/structure Manipulation Attempts",
    "KO": "MySQL UDF 삽입 및 기타 데이터/구조 조작 시도 감지"
  },
  "942360": {
    "EN": "Detects Concatenated Basic SQL Injection and SQLLFI Attempts",
    "KO": "연결된 기본 SQL 삽입 및 SQLLFI 시도 감지"
  },
  "942110": {
    "EN": "SQL Injection Attack: Common Injection Testing Detected",
    "KO": "SQL 삽입 공격: 일반적인 주입 테스트가 검색 됨"
  },
  "942120": {
    "EN": "SQL Injection Attack: SQL Operator Detected",
    "KO": "SQL 삽입 공격: SQL 연산자가 검색 되었습니다."
  },
  "942130": {
    "EN": "SQL Injection Attack: SQL Tautology Detected.",
    "KO": "SQL 삽입 공격: SQL Tautology 검색 되었습니다."
  },
  "942150": {
    "EN": "SQL Injection Attack",
    "KO": "SQL 삽입 공격"
  },
  "942180": {
    "EN": "Detects Basic SQL Authentication Bypass Attempts 1/3",
    "KO": "기본 SQL 인증 바이패스 시도 감지 1/3"
  },
  "942200": {
    "EN": "Detects MySQL Comment-/space-obfuscated Injections and Backtick Termination",
    "KO": "MySQL 주석-/공백-난독 처리된 삽입 및 억음 악센트 기호 종료 감지"
  },
  "942260": {
    "EN": "Detects Basic SQL Authentication Bypass Attempts 2/3",
    "KO": "기본 SQL 인증 바이패스 시도 감지 2/3"
  },
  "942300": {
    "EN": "Detects MySQL Comments, Conditions and ch(a)r Injections",
    "KO": "MySQL 주석"
  },
  "942310": {
    "EN": "Detects chained SQL Injection Attempts 2/2",
    "KO": "연결된 SQL 삽입 시도 감지 2/2"
  },
  "942330": {
    "EN": "Detects Classic SQL Injection Probings 1/2",
    "KO": "클래식 SQL 삽입 프로빙 감지 1/2"
  },
  "942340": {
    "EN": "Detects Basic SQL Authentication Bypass Attempts 3/3",
    "KO": "기본 SQL 인증 바이패스 시도 감지 3/3"
  },
  "942370": {
    "EN": "Detects Classic SQL Injection Probings 2/2",
    "KO": "클래식 SQL 삽입 프로빙 감지 2/2"
  },
  "942380": {
    "EN": "SQL Injection Attack",
    "KO": "SQL 삽입 공격"
  },
  "942400": {
    "EN": "SQL Injection Attack",
    "KO": "SQL 삽입 공격"
  },
  "942410": {
    "EN": "SQL Injection Attack",
    "KO": "SQL 삽입 공격"
  },
  "942430": {
    "EN": "Restricted SQL Character Anomaly Detection (args)",
    "KO": "제한된 SQL 문자 이상 감지(인수): 특수 문자 # 초과(12)"
  },
  "942450": {
    "EN": "SQL Hex Encoding Identified",
    "KO": "SQL 16진수 Encoding이 식별됨"
  },
  "942251": {
    "EN": "Detects HAVING Injections",
    "KO": "HAVING 삽입 감지"
  },
  "942420": {
    "EN": "Restricted SQL Character Anomaly Detection (cookies)",
    "KO": "제한 된 SQL 문자 이상 검색 (쿠키): 특수 문자 # 개 초과 (8)"
  },
  "942460": {
    "EN": "Meta-Character Anomaly Detection Alert - Repetitive Non-Word Characters",
    "KO": "메타 문자 이상 감지 경고 - 반복적인 단어가 아닌 문자"
  },
  "942421": {
    "EN": "Restricted SQL Character Anomaly Detection (cookies)",
    "KO": "제한 된 SQL 문자 변칙 검색 (쿠키): 특수 문자 # 개 초과 (3)"
  },
  "942432": {
    "EN": "Restricted SQL Character Anomaly Detection (args)",
    "KO": "제한 된 SQL 문자 이상 검색 (인수): 특수 문자 # 개 초과 (2)"
},
"943100": {
    "EN": "Possible Session Fixation Attack = Setting Cookie Values in HTML",
    "KO": "가능한 세션 고정 공격 = HTML의 쿠키 값 설정"
  },
  "943110": {
    "EN": "Possible Session Fixation Attack = SessionID Parameter Name with Off-Domain Referrer",
    "KO": "가능한 세션 고정 공격 = 오프-도메인 참조 페이지가 있는 SessionID 매개 변수 이름"
  },
  "943120": {
    "EN": "Possible Session Fixation Attack = SessionID Parameter Name with No Referrer",
    "KO": "가능한 세션 고정 공격 = 참조 페이지가 없는 SessionID 매개 변수 이름"
},
"949100": {
    "EN": "IP Reputation Checks",
    "KO": "IP 평판 확인"
  },
  "949110": {
    "EN": "Anomaly Mode: Overall Transaction Anomaly Score",
    "KO": "이상 모드: 전체 트랜잭션 이상 점수"
},
"950130": {
    "EN": "Directory Listing",
    "KO": "디렉터리 목록"
  },
  "950100": {
    "EN": "The Application Not Available - 5xx level status code",
    "KO": "응용 프로그램을 사용할 수 없음 - 5xx 레벨의 상태 코드시"
},
"951100": {
    "EN": "SQL Error Leakages",
    "KO": "SQL 오류 유출"
  },
  "951110": {
    "EN": "Microsoft Access SQL Information Leakage",
    "KO": "Microsoft Access SQL 정보 유출"
  },
  "951120": {
    "EN": "Oracle SQL Information Leakage",
    "KO": "Oracle SQL 정보 유출"
  },
  "951130": {
    "EN": "DB2 SQL Information Leakage",
    "KO": "DB2 SQL 정보 유출"
  },
  "951140": {
    "EN": "EMC SQL Information Leakage",
    "KO": "EMCSQL 정보 유출"
  },
  "951150": {
    "EN": "firebird SQL Information Leakage",
    "KO": "firebird SQL 정보 유출"
  },
  "951160": {
    "EN": "Frontbase SQL Information Leakage",
    "KO": "Frontbase SQL 정보 유출"
  },
  "951170": {
    "EN": "hsqldb SQL Information Leakage",
    "KO": "hsqldb SQL 정보 유출"
  },
  "951180": {
    "EN": "informix SQL Information Leakage",
    "KO": "informix SQL 정보 유출"
  },
  "951190": {
    "EN": "ingres SQL Information Leakage",
    "KO": "ingres SQL 정보 유출"
  },
  "951200": {
    "EN": "interbase SQL Information Leakage",
    "KO": "interbase SQL 정보 유출"
  },
  "951210": {
    "EN": "maxDB SQL Information Leakage",
    "KO": "maxDB SQL 정보 유출"
  },
  "951220": {
    "EN": "mssql SQL Information Leakage",
    "KO": "mssql SQL 정보 유출"
  },
  "951230": {
    "EN": "mysql SQL Information Leakage",
    "KO": "mysql SQL 정보 유출"
  },
  "951240": {
    "EN": "postgres SQL Information Leakage",
    "KO": "postgres SQL 정보 유출"
  },
  "951250": {
    "EN": "sqlite SQL Information Leakage",
    "KO": "sqlite SQL 정보 유출"
  },
  "951260": {
    "EN": "Sybase SQL Information Leakage",
    "KO": "Sybase SQL 정보 유출"
},
"952100": {
    "EN": "Java Source Code Leakages",
    "KO": "자바 소스 코드 유출"
  },
  "952110": {
    "EN": "Java Errors",
    "KO": "자바 오류"
},
"953100": {
    "EN": "PHP Error Message Leakage",
    "KO": "PHP 오류 메시지 유출"
  },
  "953110": {
    "EN": "PHP Source Code Leakage",
    "KO": "PHP 소스 코드 유출"
  },
  "953120": {
    "EN": "Detect The Presence of the PHP Open Tag",
    "KO": "자바 오류 PHP 오픈 태그의 존재 감지"
},
"954100": {
    "EN": "Disclosure of IIS install location",
    "KO": "IIS 설치 위치 공개"
  },
  "954110": {
    "EN": "Application Availability Error",
    "KO": "애플리케이션 가용성 오류"
  },
  "954120": {
    "EN": "IIS Information Leakage",
    "KO": "IIS 정보 유출"
  },
  "954130": {
    "EN": "IIS Information Leakage",
    "KO": "IIS 정보 유출"
},
"959100": {
    "EN": "Alert and Block on High Anomaly Scores",
    "KO": "높은 이상 스코어에 대한 경고 및 차단"
},
"980100": {
    "EN": "Correlated Successful Attack",
    "KO": "상관 관계가있는 성공적인 공격"
  },
  "980110": {
    "EN": "Correlated Attack Attempt",
    "KO": "상관된 공격 시도"
  },
  "980120": {
    "EN": "Inbound Anomaly Score Exceeded",
    "KO": "인바운드 이상 점수 초과"
  },
  "980130": {
    "EN": "Inbound Anomaly Score Exceeded ",
    "KO": "인바운드 이상 점수 초과"
  },
  "980140": {
    "EN": "Outbound Anomaly Score Exceeded",
    "KO": "아웃바운드 이상 점수 초과"
  },
  "1000001" : {
    "EN" : "Malicious Request URI detected by Custom Policy",
    "KO" : "사용자 지정 정책에서 탐지된 악의적인 요청 URI"
  },
  "1000002" : {
    "KO" : "사용자 지정 정책에 의해 차단된 악의적인 경로",
    "EN" : "Malicious Path blocked by Custom Policy"
  },
  "1000020" : {
    "KO" : "사용자 지정 정책에 의해 차단된 악의적인 IP",
    "EN" : "Malicious IP blocked by Custom Policy"
  },
  "1000010" : {
    "KO" : "IP 주소가 사용자 지정 정책에 의한 화이트리스트임",
    "EN" : "IP Address is Whitelist by Custom Policy"
  },
  "933131" : {
    "EN" : "PHP Injection Attack: Variables Found",
    "KO" : "PHP 코드 삽입 공격 : PHP 문법 변수 탐지"
  },
  "941130" : {
    "EN" : "XSS Filter - Category 3 = Attribute Vector",
    "KO" : "XSS 필터 - 범주 3 = 속성 벡터"
  },
  "942431" : {
    "EN" : "Restricted SQL Character Anomaly Detection (args)",
    "KO" : "제한된 SQL 문자 이상 탐지(arg)"
  },
  "4200011"	 : {
    "EN" : "Gnuboard Vulnerability	Block	PL1	critical",
    "KO" : "Gnuboard 취약성 블록 PL1 중요"
  },
	"4200012"	 : {
    "EN" : "TechNote Vulnerability	Block	PL1	critical",
    "KO" : "TechNote 취약성 블록 PL1 중요"
  },
	"4200013"	 : {
    "EN" : "ZeroBoard Vulnerability - except dir	Block	PL1	critical",
    "KO" : "ZeroBoard 취약성 - dir 블록 PL1을 제외하고 중요"
  },
	"4200014"	 : {
    "EN" : "Common Board Vulnerabilities	Block	PL1	critical",
    "KO" : "공통 보드 취약성 블록 PL1 중요"
  },
	"4200015"	 : {
    "EN" : "PHP Code Injection - base64_decode	Block	PL1	critical",
    "KO" : "PHP 코드 주입 - base64_decode 블록 PL1 중요"
  },
	"4200016"	 : {
    "EN" : "Java Code Injection - Runtime	Block	PL1	critical",
    "KO" : "Java 코드 주입 - 런타임 블록 PL1 중요"
  },
	"4200017"	 : {
    "EN" : "Command Injection	Block	PL1	critical",
    "KO" : "명령 주입 블록 PL1 중요"
  },
	"4200018"	 : {
    "EN" : "wget Command Injection	Block	PL1	critical",
    "KO" : "wget 명령 주입 블록 PL1 중요"
  },
	"4200019"	 : {
    "EN" : "Remote File Inclusion	Block	PL1	critical",
    "KO" : "원격 파일 포함 블록 PL1 중요"
  },
	"4200020"	 : {
    "EN" : "Detect phpinfo Injection	Block	PL1	critical",
    "KO" : "phpinfo 주입 블록 PL1 검출 중요"
  },
	"4200021"	 : {
    "EN" : "Web Shell - Code Injection - Common	Block	PL1	critical",
    "KO" : "웹 셸 - 코드 주입 - 공통 블록 PL1 중요"
  },
	"4200022"	 : {
    "EN" : "Detect ASP Config	Block	PL1	critical",
    "KO" : "ASP 구성 블록 PL1 탐지 중요"
  },
	"4200023"	 : {
    "EN" : "Access Web Setting files	Block	PL1	critical",
    "KO" : "웹 설정 파일 액세스 PL1 차단 중요"
  },
	"4200024"	 : {
    "EN" : "Remote Command Execution	Block	PL1	critical",
    "KO" : "원격 명령 실행 블록 PL1 중요"
  },
	"4200025"	 : {
    "EN" : "Vulnerabilities - ASP Sample Pages	Block	PL1	critical",
    "KO" : "취약성 - ASP 샘플 페이지 블록 PL1 중요"
  },
	"4200026"	 : {
    "EN" : "Vulnerabilities - CGI Sample Pages",
    "KO" : "취약성 - CGI 샘플 페이지"
  }
}
